import { render, staticRenderFns } from "./DistributionRevenueDeliveryRate.vue?vue&type=template&id=b6e05522&scoped=true&"
import script from "./DistributionRevenueDeliveryRate.vue?vue&type=script&lang=js&"
export * from "./DistributionRevenueDeliveryRate.vue?vue&type=script&lang=js&"
import style0 from "./DistributionRevenueDeliveryRate.vue?vue&type=style&index=0&id=b6e05522&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e05522",
  null
  
)

export default component.exports